import React, { useState, useEffect, useContext } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  medicationListById,
  saveMutation,
} from '../../../shared/queries/Medication';
import GraphQL from '../../../GraphQL';
import MedicacaoForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import { upLoadFile, calculateAge } from '../../../shared/utils/smartutils';
import SmartContext from '../../App/context/SmartContext';

const MedicationFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0 });
  const [formOn, setFormOn] = useState(false);
  const context = useContext(SmartContext);
  const { loggedUser } = context;
  function backClickHandler() {
    history.push('/minime/medicacao');
  }
  function showLoading() {
    dispatch(changeLoadingTrue());
  }
  function hideLoading() {
    dispatch(changeLoadingFalse());
  }
  function findById(id) {
    showLoading();
    const query = medicationListById(id);
    GraphQL(query, {})
      .then((res) => {
        if (res.medicationListByFilter) {
          setDto({
            ...res.medicationListByFilter[0],
            initialDate: res.medicationListByFilter[0].initialDate
              ? new Date(res.medicationListByFilter[0].initialDate)
              : new Date(),
            finalDate: res.medicationListByFilter[0].finalDate
              ? new Date(res.medicationListByFilter[0].finalDate)
              : new Date(),
            student: {
              ...res.medicationListByFilter[0].student,
              label: res.medicationListByFilter[0].student.fullName,
              value: res.medicationListByFilter[0].student.id,
              age: calculateAge(
                res.medicationListByFilter[0].student.dateOfBirth
              ),
            },
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }
  const handleSubmit = async (values) => {
    showLoading();
    let uploadedFile;
    if (values.files && values.files.length) {
      if (!values.files[0].fileId) {
        uploadedFile = await upLoadFile(values.files[0]);
      } else {
        uploadedFile = { fileId: dto.fileId };
      }
    } else {
      uploadedFile = { fileId: '' };
    }
    const updatedValues = { ...values, requester: loggedUser.name };
    const mutation = saveMutation(updatedValues, uploadedFile);
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };
  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);
  return (
    <SmartCard title={t('mnt_medication.title')}>
      {formOn ? (
        <MedicacaoForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          showLoading={showLoading}
          hideLoading={hideLoading}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

MedicationFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(MedicationFormHandler)
);
